"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

/**
 * Renders children wrapped inside a link to a internal/external site.
 *
 * @param {string} to A route to link to.
 * @param {boolean} external If link is navigating to external site
 * @param {boolean} newTab Opens link within new tab
 * @param {boolean} redirectOnRender Redirects user to link once component renders
 * @param {string} redirectOnRenderReturnUrl Route to return if back button pressed from automatic redirect on render
 * @param {function} onClick Function that gets called when a user clicks on a link
 * @param {string} queryParameters A string representation of query parameters.
 * @param {[function]} children Children components to render inside of link
 *
 * @example
 * <Link to="/about-us">About Us</Link>
 */
var Link = function Link(_ref) {
  var to = _ref.to,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? false : _ref$newTab,
      _ref$redirectOnRender = _ref.redirectOnRender,
      redirectOnRender = _ref$redirectOnRender === void 0 ? false : _ref$redirectOnRender,
      _ref$redirectOnRender2 = _ref.redirectOnRenderReturnUrl,
      redirectOnRenderReturnUrl = _ref$redirectOnRender2 === void 0 ? "/" : _ref$redirectOnRender2,
      _onClick = _ref.onClick,
      _ref$queryParameters = _ref.queryParameters,
      queryParameters = _ref$queryParameters === void 0 ? "" : _ref$queryParameters,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children;

  if (redirectOnRender) {
    if (typeof window !== "undefined") {
      window.location.href = "" + to + queryParameters;
    } else {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: redirectOnRenderReturnUrl
      });
    }
  }

  if (external) {
    if (!newTab) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "" + to + queryParameters,
        onClick: function onClick() {
          if (_onClick) {
            _onClick();
          }
        },
        style: style
      }, children);
    }

    return /*#__PURE__*/_react["default"].createElement("a", {
      href: "" + to + queryParameters,
      target: "_blank",
      rel: "noopener noreferrer",
      style: style,
      onClick: function onClick() {
        if (_onClick) {
          _onClick();
        }
      }
    }, children);
  }

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: {
      pathname: to,
      search: queryParameters
    },
    rel: newTab ? "noopener noreferrer" : "",
    target: newTab ? "_blank" : "",
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    },
    style: style
  }, children);
};

var _default = Link;
exports["default"] = _default;